<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <span class="label has-text-primary">Add your filters</span>
    </header>
    <section class="modal-card-body">
      <template v-for="f in filters">
        <component :is="f.type" :key="f.key"
          :label="f.label" :queryKey="f.queryKey" :query="currentFilters[f.key]"
          v-bind="f.props"
          @input="v => handleFilterChange((f.customMapper || defaultMapper)(v, f.key))"
          />
        <hr :key="`${f.key}-hr`"/>
      </template>
    </section>

    <button class="button is-primary" @click="apply">Apply</button>

  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import NumberRangeFilter from './NumberRangeFilter';
import MultipleAutoCompleteFilter from './MultipleAutoCompleteFilter';
import DateFilter from './DateFilter';
import TextFilter from './TextFilter';
import DateRangeFilter from './DateRangeFilter';
import OptionFilter from './OptionFilter';

export default {
  components: {
    DateFilter,
    DateRangeFilter,
    NumberRangeFilter,
    MultipleAutoCompleteFilter,
    TextFilter,
    OptionFilter,
  },
  props: {
    filters: Array,
    initialFilters: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      currentFilters: {},
    };
  },
  methods: {
    handleFilterChange({ key, value }) {
      this.$set(this.currentFilters, key, value);
    },
    apply() {
      this.$emit('input', this.currentFilters);
      this.$emit('close');
    },
    defaultMapper(value, key) {
      return { key, value };
    },
  },
  created() {
    this.currentFilters = cloneDeep(this.initialFilters);
  },

};
</script>

<style lang="scss" scoped>
.modal-card {
  width: auto;
}

.modal-card-body {
  padding-bottom: 13rem;
}

hr {
  margin: 1rem;
}

/deep/ .dropdown.is-mobile-modal .dropdown-menu {
  position: fixed;
  width: calc(100vw - 40px);
  max-width: 460px;
  max-height: calc(100vh - 120px);
  top: 25% !important;
  left: 50% !important;
  bottom: auto !important;
  right: auto !important;
  -webkit-transform: translate3d(-50%, -25%, 0);
  transform: translate3d(-50%, -25%, 0);
  white-space: normal;
  overflow-y: auto;
}

/deep/ .dropdown .background {
    display: block;
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    position: fixed;
    background-color: rgba(10, 10, 10, 0.86);
    z-index: 10;
    cursor: pointer;
}
</style>
